import Vue from 'vue';
import vuescroll from 'vuescroll';
// import VueI18n from 'vue-i18n';
// import moment from 'moment';
import VueLazyload from 'vue-lazyload';
import 'vue2-toast/lib/toast.css';
import Toast from 'vue2-toast';
import sa from '@/common/sensors';

import App from './App.vue';
import router from './router';
import store from './store';
import { i18n, DEFAULT_LANG } from '@/locales/index'

import VueAliplayerV2 from 'vue-aliplayer-v2';
import Storage from '@common/storage'
import 'vant/lib/index.css'
import '@/assets/css/reset.less';
import '@/assets/css/theme.less'
import '@/utils/flexible';
import { bindInviteCodeKey } from "@/constant/storageKey";
// import { Locale } from 'vant';
// 引入英文语言包
// import enUS from 'vant/es/locale/lang/en-US';
import { SLS } from '@common/utils'
import { isActivityPath, getQueryObj, getUrlQuery }from '@/utils'


import * as BrowserLogger from 'alife-logger';

try{
    const __bl = BrowserLogger.singleton({
        pid:"1ltn9vrvz5f@e2253b455731439",
        appType:"web",
        imgUrl:"https://arms-retcode-sg.aliyuncs.com/r.png?",
        sendResource:true,
        enableLinkTrace:true,
        behavior:true,
        enableSPA: true,
        useFmp: true,
        enableApiCors: true,
        environment: process.env.NODE_ENV === 'development' ? 'local' : process.env.VUE_APP_ARMS_ENV
    });

	__bl.setConfig({
		ignore: {
			// 忽略第三方请求头添加阿里日志追踪标记 eagleeye-pappname/eagleeye-sessionid/eagleeye-traceid
			ignoreApis: [
				(str) => {
					const whiteList = [
						'api-test.shopshops.top',
						'api-uat.shopshops.top',
						'api-release.shopshops.top',
						'api.shopshops.top'
					]
					for (let i in whiteList) {
						if (str.includes(whiteList[i])) {
							return false
						}
					}
					return true
				}
			],
			// 忽略 Script error错误
			ignoreErrors: /^Script error\.?$/
		}
	});

    Vue.prototype.$aliArms = __bl;

    // @todo 将__bl挂到window的原因：以前__bl是用src方式引入,__bl挂在window上。为了少动代码才重新挂回去
    window.__bl = __bl;
}catch(e){
    console.log(e);
}

Vue.use(VueAliplayerV2)
// cssLink: 'https://fr-static.shopshops.top/static/css/aliplayer/2.8.2/aliplayer-min.css'
// Vue.use(VueAliplayerV2,{
//   cssLink: 'https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css',
//   scriptSrc: 'https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js'
// });
// import zh from '@/config/zh.json';
// import en from '@/config/en.json';

Vue.use(vuescroll);
// Vue.use(VueI18n);
Vue.use(VueLazyload, {
	preLoad: 2,
})
import { Popup, NumberKeyboard } from 'vant';
Vue.use(Popup);
Vue.use(NumberKeyboard);

// Vue.use(VueAliplayerV2);
import loading from '@/directives/loading'
Vue.use(loading)

// 设置localstorage有效期，默认7天
const myStorage = new Storage({ exp: 7 * 24 * 60 * 60 })
Vue.prototype.$storage = myStorage
window.$storage = myStorage

const aliSLS = new SLS({ logstore: 1 });
Vue.prototype.$aliSLS = aliSLS;

Vue.prototype.$aliPlayerSetlogCBK = () => {
	if (window.Aliplayer && !window.Aliplayer.__logCallback__) {
		window.Aliplayer.__logCallback__ = (params) => {
			aliSLS.send(params);
		}
	}
}

Vue.prototype.$isZh = DEFAULT_LANG;

// 初始化i18n插件
// const DEFAULT_LANG = 'zh-cn';
// Locale.use('en-US', enUS);
// const DEFAULT_LANG = 'en';
// const locales = {
//   'zh-cn': zh,
//   en,
// };
// const i18n = new VueI18n({
//   locale: DEFAULT_LANG,
//   messages: locales,
// });

// 初始化moment插件
// moment.locale(DEFAULT_LANG);
// Vue.prototype.$moment = moment;
Vue.config.productionTip = false;



import { priceSeparator } from '@/utils/formatUtil';
Vue.prototype.$priceSeparator = priceSeparator

import CurrencyFormatter from 'currencyformatter.js'
Vue.prototype.$currencyFormatter = function (money) {
	money = money ? money - 0 : 0
	return CurrencyFormatter.format(money, { symbol: null, pattern: '#,##0.00 !' })
}
// 初始化toast组件
Vue.use(Toast, {
	type: 'center',
	duration: 1500,
	wordWrap: true,
	width: '5rem'
});

sa.init()
sa.autoTrack()
import login from '@/components/login'
// import inviteLogin from '@/components/inviteLogin'
Vue.use(login, i18n);
// Vue.use(inviteLogin, i18n);
// Vue.prototype.$login = login;
/**
 * 判断登录状态
 * @param {*} loginSuccess  登录成功后的回调。 如果当前已登录，直接执行回调。
 * @param {*} autoShowLoginPanel  未登录时是否自动唤起登录面板
 * @returns 
 */
Vue.prototype.$isLogin = function (loginSuccess, autoShowLoginPanel = true) {
	let userInfo = this.$storage.get('user_info') || null;
	
	if ( !userInfo ) {
		if( autoShowLoginPanel ){

			this.$login.open( function () {
				let { userNum, inviteUserNum, newUser } = this.$storage.get('user_info');
				// let _urlQuery = getQueryObj();

				if( !isActivityPath()){

					this.$welcome.open(()=>{
						// && _urlQuery.code && _urlQuery.activityType == 'inviteCode'
						// 关闭弹窗后 触发 onCose 事件 - 并跳转首页
						if (  newUser && !this.$storage.get(bindInviteCodeKey + userNum) && !inviteUserNum ) {
							// 绑定邀请码弹窗
							this.$bindInviteCode.open({
								bindComplete: (bindResult) => {
									if (loginSuccess) {
										loginSuccess();
									}
									// if (bindResult) {
									// 	this.$downloadGuide.open();
									// }
								}
							});
				
						} else if (loginSuccess) {
							loginSuccess();
						}	
					});

				}else{
					loginSuccess && loginSuccess();
				}
				
			}.bind(this) );
		}
		return false
	} else {
		loginSuccess && loginSuccess();
		return true
	}
}

import share from '@/components/share'
Vue.use(share, i18n);
// Vue.prototype.$shareGuide = share;

import welcome from '@/components/share/welcome'
Vue.use(welcome, i18n);

import bindMobile from './components/bindMobile';
Vue.use(bindMobile, i18n);
// Vue.prototype.$bindMobile = bindMobile;

import { handleImg } from '@/utils/imageUtil'
Vue.prototype.handleImg = handleImg

import order from '@/components/shop/order'
Vue.use(order, i18n);
// Vue.prototype.$order = order

import sku from '@/components/shop/sku'
Vue.use(sku, i18n);
// Vue.prototype.$sku = sku

import inviteCode from '@/components/inviteCode'
Vue.use(inviteCode, i18n);
// Vue.prototype.$bindInviteCode = inviteCode

import downloadGuide from '@/components/inviteCode/downloadGuide'
Vue.use(downloadGuide, i18n);
// Vue.prototype.$downloadGuide = downloadGuide


import createAccount from '@/components/createAccount'
Vue.use(createAccount, i18n);


// 添加手势触摸事件，使用方法如 v-touch:swipeleft
import VueTouch from '@/config/nim/plugins/touchEvent'
Vue.use(VueTouch)

 // 2.21版本不在使用七鱼客服
// import '@/config/qiyu'

require('./utils/polyfill')

const vm = new Vue({
	i18n,
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');

export default vm
